export default __webpack_public_path__ + "static/media/480_dummy2016-heilpraxis01-de.dbbe91ef.png";